import "./index.css"
import Button from "../button";
import { useState } from "react";
import { submitNewUrl } from "../../functions/submitUrl";

function InputModule({display,functionForButton}) {
  const [stageNumber, SetStageNumber] = useState(0);
  const [isError,SetIsError] = useState(false);
  const [errorMessage,SetErrorMessage] = useState("")

  const goToSites = () => {
    window.location.href = '/sites';
  }

  const handleClose = () =>{
    document.getElementById("url-input-field").value = ""
    SetStageNumber(0);
    functionForButton()
  }

  const handleClick = async () => {
    let newURL = document.getElementById("url-input-field").value;
    let response = await submitNewUrl(newURL,SetIsError,SetErrorMessage);
    if(response === true){
      let currentState = stageNumber;
      SetStageNumber(currentState + 1);
    }
  }


    const [stages,SetStage] = useState([
      { 
        title:'Add an input',
        body:'Enter the root domain of a website you want to crawl to generate social copy from.',
        displayOfInputBar:true,
        ctaText:'Add input',
        completeFunction: handleClick,
      },
      { 
        title:'What now?',
        body:'Your site has been added, and we will crawl this site to find new posts and content, which will then appear in your feed. You may not see anything just yet as we find typically sites post content a couple times a week. You will receive email alerts the second we detect any new posts!',
        displayOfInputBar:false,
        ctaText:'Show my sites',
        completeFunction: goToSites,
      }
    ])

    return <div id="blur-wrapper" style={{display:display}}>
    <div id="add-module">
    <div className="input-module-title-holder">
    <h2 className="big-text">{stages[stageNumber].title}</h2>
    <img alt="close" src="./images/close.png" onClick={handleClose} />
    </div>
    <div className="small-text">{stages[stageNumber].body}</div>
    <div style={{display : stages[stageNumber].displayOfInputBar ? 'block' : 'none'}}>
    <div className="small-text label">Domain name</div>
    <input id="url-input-field" className="small-text" type="url" placeholder=""></input>
    </div>
    <div id="input-error-module" style={{display : isError ? "block" : "none"}} dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
    <div className="button-holder">
    <Button text={stages[stageNumber].ctaText} addedFunction={stages[stageNumber].completeFunction}></Button>
    </div>
    </div>
    </div>;
  }

export default InputModule;